const style = {
    dashboardContainer: {
      width: "100%",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "40px",
    },
    title: {
      fontSize: "32px",
      fontWeight: "600",
      color: "#E6EDF3",
      margin: 0,
    },
    subtitle: {
      fontSize: "16px",
      color: "#8B949E",
      margin: "4px 0 0 0",
    },
    headerButton: {
      backgroundColor: "#58A6FF",
      color: "#0D1117",
      border: "none",
      borderRadius: "8px",
      padding: "12px 20px",
      cursor: "pointer",
      fontWeight: "600",
      fontSize: "14px",
      transition: "opacity 0.2s ease",
    },
    cardsContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
      gap: "24px",
      marginBottom: "40px",
    },
    card: {
      backgroundColor: "rgba(22, 27, 34, 0.8)",
      borderRadius: "16px",
      padding: "24px",
      border: "1px solid #30363D",
      backdropFilter: "blur(10px)",
    },
    cardIconWrapper: {
      width: "48px",
      height: "48px",
      borderRadius: "12px",
      backgroundColor: "rgba(88, 166, 255, 0.1)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "22px",
      marginBottom: "20px",
    },
    cardTitle: {
      fontSize: "14px",
      fontWeight: "500",
      color: "#8B949E",
      margin: "0 0 8px 0",
    },
    cardValue: {
      fontSize: "28px",
      fontWeight: "600",
      color: "#E6EDF3",
      margin: 0,
    },
    tableContainer: {
      backgroundColor: "rgba(22, 27, 34, 0.8)",
      borderRadius: "16px",
      padding: "24px",
      border: "1px solid #30363D",
      backdropFilter: "blur(10px)",
    },
    tableTitle: {
      fontSize: "18px",
      fontWeight: "600",
      color: "#E6EDF3",
      marginBottom: "20px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    tableHeadRow: {
      borderBottom: "1px solid #30363D",
    },
    tableHeader: {
      padding: "0 0 12px 0",
      textAlign: "left",
      fontSize: "12px",
      color: "#8B949E",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    tableRow: {
      borderBottom: "1px solid #30363D",
    },
    tableCell: {
      padding: "16px 0",
      fontSize: "14px",
      color: "#E6EDF3",
      fontWeight: "500",
    },
    valueCell: {
      textAlign: "right",
      fontFamily: "'Roboto Mono', monospace",
    },
    statusBadge: {
      padding: "4px 12px",
      borderRadius: "9999px",
      fontSize: "12px",
      fontWeight: "600",
      display: "inline-block",
    },
    statusPaid: {
      backgroundColor: "rgba(4, 120, 87, 0.3)",
      color: "#34D399",
    },
    statusPending: {
      backgroundColor: "rgba(217, 119, 6, 0.3)",
      color: "#FBBF24",
    },
    statusRefunded: {
      backgroundColor: "rgba(153, 27, 27, 0.3)",
      color: "#F87171",
    },
  };
  
  export default style;